<template>
  <div class="file-uploaded margin-top-10">
    <div
      class="file clickable flex-row flex__between padding-left-10"
      @click="downloadFile"
    >
      <a class="flex-row flex__left">
        <file-type-image :fileExtention="'pdf'" />
        <span class="fileName font-weight_normal">Xem nội dung văn bản</span>
      </a>
      <a class="clickable icon-download-file margin-right-10">
        <i class="fas fa-cloud-download color__white font-size__medium"></i>
      </a>
    </div>
  </div>
</template>

<script>
import constants from "../../../constants";
import { vbAttachmentTdhvpService } from "../../../services/tdhvp/vbAttachmentTdhvpService";
import FileTypeImage from "../../job/FileTypeImage";

export default {
  name: "tdhvp-doc-download",
  props: ["docId", "docType", "userDeptRoleId"],
  components: { FileTypeImage },

  methods: {
    downloadFile() {
      switch (this.docType) {
        case constants.ATTACHMENT_OBJECT_TYPE.VB_DEN:
          vbAttachmentTdhvpService.downloadVbIncomingDoc(
            this.userDeptRoleId,
            this.docId
          );
          break;
        case constants.ATTACHMENT_OBJECT_TYPE.VB_DI:
          vbAttachmentTdhvpService.downloadVbOutgoingDoc(
            this.userDeptRoleId,
            this.docId
          );
          break;
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/common/tdhvp-doc-download.vue